export default {
  getEvent: {
    method: 'GET',
    url: 'events/:id',
  },
  getInvitationsOfEvent: {
    method: 'GET',
    url: 'events/:id/invitations',
  },
};
